<template>
    <div id="createKalameeting" class="container text-center">
        <Navigator></Navigator>
        <div class="row py-5">
            <h3 class="col-12">Create Kalameeting</h3>
        </div>
            <b-form @submit.prevent="create" class="row text-left">
                <div class="col-12 col-md-6 mx-auto ">
                    <h6>Meeting info</h6>
                    <b-form-group label="Kalameeting Name" label-for="kalameeting-name">
                        <b-form-input id="kalameeting-name" v-model="kalameeting.name"
                                      type="text" placeholder="The Saturday Night Kalameeting"/>
                    </b-form-group>
                    <b-form-group label="Date" label-for="date">
                        <b-form-datepicker id="date" v-model="kalameeting.date"
                                      type="date" placeholder="Pick the day"/>
                    </b-form-group>
                    <b-form-group label="Start Time"  label-for="startTime">
                        <b-form-timepicker id="startTime" v-model="kalameeting.startTime"
                                      type="time" placeholder="Starting Time"/>
                    </b-form-group>
                    <b-form-group label="End Time"  label-for="endTime">
                        <b-form-timepicker id="endTime" v-model="kalameeting.endTime"
                                      type="time" placeholder="End Time"/>
                    </b-form-group>
                </div>
                <div class="col-12 col-md-6">
                    <h6>Meeting Slots</h6>
                    <b-form-group label="Time slot for each fan (minutes)" label-for="timeSlot">
                        <b-form-spinbutton  id="timeSlot" v-model="kalameeting.timeSlot"
                                      type="number" placeholder="Pick the slot"/>
                    </b-form-group>
                    <b-form-group label="Slot Price (€)"
                                  description="How much break time do you need?"
                                  label-for="slotPrice">
                        <b-form-input  id="slotPrice" v-model="kalameeting.slotPrice"
                                      type="number" placeholder="Select an amount"/>
                    </b-form-group>
                    <md-divider class="m-3"></md-divider>
                    <h6>Break Time</h6>
                    <b-form-group label="Number of meetings in a row"
                                  description="After how many meetings do you want have a break?"
                                  label-for="slotsInARow">
                        <b-form-spinbutton  id="slotsInARow" v-model="kalameeting.slotsInARow"
                                      type="number" placeholder="Select"/>
                    </b-form-group>
                    <b-form-group label="Break time (minutes)"
                                  description="How much break time do you need?"
                                  label-for="breakTime">
                        <b-form-spinbutton  id="breakTime" v-model="kalameeting.breakTime"
                                      type="number" placeholder="Select"/>
                    </b-form-group>
                </div>
                <div class="col-8 mx-auto text-center" v-if="calculated">
                    <h5>Quote</h5>
                    <md-divider class="m-1 bg-secondary"></md-divider>
                    Total Tickets: <b>{{kalameeting.totalTickets}}</b><br>
                    Line will start: <b>{{kalameeting.lineStart.toLocaleDateString()}}
                    {{kalameeting.lineStart.toLocaleTimeString()}}</b><br>
                    Sold Out Revenue: <b>{{soldOutRevenue}}</b><br>
                    Sold Out Fees: <b>{{soldOutFees}}</b>
                    <md-divider class="m-1 bg-secondary"></md-divider>
                </div>
                <div class="text-center py-3 col-12 text-center">

                    <b-button v-if="calculated"
                              class="m-1" pill @click="create">Create Kalameeting</b-button>
                    <b-button v-if="!calculated" class="m-1" pill
                              @click="calculate">Calculate</b-button><br>
                    <b-button v-if="calculated" class="m-1" pill
                              @click="calculate" variant="dark">Recalculate</b-button>
                    <b-button class="m-3" variant="dark" @click="reset" pill>Reset</b-button>
                    <br>
                    <router-link to="Home">Back Home</router-link>
                </div>
            </b-form>
        <transition name="fade">
            <div v-if="errorMsg !== ''" class="error-msg">
                <p>{{ errorMsg }}</p>
            </div>
        </transition>
    </div>
</template>

<style lang="scss" scoped>
    #createKalameeting {
        background: #06424d;
        min-height: 100%;
        min-width: 100%;
        color: white;
    }
    .kalameetbody {
        width: 100%;
    }
</style>

<script>
import firebase from '@/firebase';
import Navigator from '../../components/Navigator.vue';

export default {
    data() {
        return {
            errorMsg: '',
            calculated: false,
            soldOutRevenue: 0,
            soldOutFees: 0,
            kalameeting: {}
        };
    },
    created() {
        this.reset();
    },
    methods: {
        calculate() {
            this.errorMsg = '';
            this.calculated = true;
            const totalMinutes = this.getTotalMinutes();
            this.kalameeting.totalTickets = 0;
            let i = 0;
            while (i <= totalMinutes) {
                for (let b = 0; b < this.kalameeting.slotsInARow; b += 1) {
                    i += this.kalameeting.timeSlot;
                    this.kalameeting.totalTickets += 1;
                }
                i += this.kalameeting.breakTime;
            }

            this.kalameeting.availableTickets = this.kalameeting.totalTickets;
            this.soldOutRevenue = this.kalameeting.totalTickets * this.kalameeting.slotPrice;
            this.soldOutFees = this.soldOutRevenue * 0.10;
            this.soldOutRevenue -= this.soldOutFees;
            this.kalameeting.lineStart = this.calculateLineStart();
        },
        getTotalMinutes() {
            const endTimes = this.kalameeting.endTime.split(':');
            const startTimes = this.kalameeting.startTime.split(':');
            const endDate = new Date(this.kalameeting.date);
            endDate.setHours(endTimes[0]);
            endDate.setMinutes(endTimes[1]);
            endDate.setSeconds(endTimes[2]);
            const startDate = new Date(this.kalameeting.date);
            startDate.setHours(startTimes[0]);
            startDate.setMinutes(startTimes[1]);
            startDate.setSeconds(startTimes[2]);
            const diffMs = endDate - startDate;
            const diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
            const diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
            return diffHrs * 60 + diffMins;
        },
        calculateLineStart() {
            const startTimes = this.kalameeting.startTime.split(':');
            const lineDate = new Date(this.kalameeting.date);
            lineDate.setHours(lineDate.getHours() - 1);
            lineDate.setMinutes(startTimes[1]);
            lineDate.setSeconds(startTimes[2]);
            return lineDate;
        },
        reset() {
            this.calculated = false;
            const now = new Date();
            const inAnHour = new Date();
            inAnHour.setHours(now.getHours() + 2);
            const inTwoHours = new Date();
            inTwoHours.setHours(now.getHours() + 3);
            this.kalameeting = {
                name: '',
                date: inAnHour,
                startTime: `${inAnHour.getHours()}:00:00`,
                endTime: `${inTwoHours.getHours()}:00:00`,
                timeSlot: 3,
                slotPrice: 100,
                slotsInARow: 6,
                breakTime: 10,
                totalTickets: 0,
                availableTickets: 0,
                lineStart: 0,
                owner: {
                    uid: this.$store.state.currentUser.uid,
                    firstName: this.$store.state.userProfile.firstName,
                    lastName: this.$store.state.userProfile.lastName
                }
            };
        },
        create() {
            if (!this.kalameeting.name) {
                this.errorMsg = 'Kalameeting Name is mandatory';
            } else if (this.$store.state.userProfile.role !== 'VIP') {
                this.errorMsg = 'You are not authorised to create kalameetings!';
            } else {
                this.kalameeting.date = new Date(this.kalameeting.date).getTime();
                this.kalameeting.lineStart = new Date(this.kalameeting.lineStart).getTime();
                firebase.kalameetingCollection.doc()
                    .set(this.kalameeting)
                    .then(() => {
                        this.$router.push('Home');
                    })
                    .catch((err) => {
                        this.errorMsg = err.message;
                        console.log(err);
                    });
            }
        }
    },
    components: {
        Navigator
    }
};
</script>
